"use client";

import 'react-image-crop/src/ReactCrop.scss';
import { Provider } from "react-redux";
import { ToastContainer, } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { store } from "~/redux_store";
import "./globals.scss";

export default function RootLayout({
	children,
}: Readonly<{
	children: React.ReactNode;
}>) {
	return (
		<html lang="en">
			<head>
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1.0" />
				<meta name="description" content="AssetFractio" />
				<meta name="keywords" content="AssetFractio,asset,fractio" />
				<link rel="icon" href="/favicon.ico" />
				<link rel="preconnect" href="https://fonts.googleapis.com" />
				<link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
				<link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&family=Mulish:ital,wght@0,200..1000;1,200..1000&family=Poppins:wght@400;600&family=Red+Hat+Display:ital,wght@0,300..900;1,300..900&display=swap" rel="stylesheet"></link>
				<title>AssetFractio</title>
			</head>
			<Provider store={store}>
				<body className={`relative overflow-x-hidden overflow-y-auto min-w-[1300px] min-h-[100vh] max-h-[100vh]`}>
					<div className="absolute top-0 left-0 min-w-full max-w-full overflow-y-auto min-h-full max-h-full">
						{children}
					</div>
					<ToastContainer />
					<div className="absolute top-0 left-0 w-full h-full hidden" id="modal-container"></div>
					<div id="hidden-portal" className="hidden absolute -top-[1000vh]"></div>
				</body>
			</Provider>
		</html>
	);
}
